export default __webpack_public_path__ + "static/revolutionizing-forklift-4eeb55233403f392dbdc218700d44802.png";